var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 39,
    rx: 5,
    fill: "#E4F3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6005_42553",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5H31.5V31.5H7.5V7.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6005_42553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2526 10.5306C23.7111 9.80868 23.0091 9.22273 22.202 8.8191C21.3949 8.41548 20.505 8.20525 19.6026 8.20508H19.3916C18.4892 8.20525 17.5992 8.41548 16.7921 8.8191C15.9851 9.22273 15.283 9.80868 14.7416 10.5306C14.4073 10.9763 14.2266 11.5184 14.2266 12.0756V14.9806C14.2266 16.3788 14.782 17.7198 15.7707 18.7084C16.7594 19.6971 18.1003 20.2526 19.4986 20.2526C20.8962 20.2517 22.2362 19.6958 23.2242 18.7072C24.2121 17.7186 24.7671 16.3782 24.7671 14.9806V12.0756C24.7671 11.5184 24.5869 10.9763 24.2526 10.5306Z",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2266 14.2302C14.4654 14.2299 14.7019 14.1825 14.9225 14.0908C15.1431 13.9991 15.3434 13.8648 15.5121 13.6957L16.4856 12.7217C17.4209 13.1894 18.4523 13.4329 19.4981 13.4329C20.5438 13.4329 21.5752 13.1894 22.5106 12.7217L23.4846 13.6957C23.8255 14.0366 24.2879 14.2281 24.7701 14.2282",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7932 30.7974L29.2082 26.0419C29.0025 25.4251 28.6407 24.872 28.1578 24.4365C27.6749 24.001 27.0875 23.698 26.4527 23.5569L21.7557 22.5134L19.4962 26.2789L17.2367 22.5134L12.5397 23.5569C11.905 23.698 11.3176 24.001 10.8347 24.4365C10.3518 24.872 9.98993 25.4251 9.78424 26.0419L8.19922 30.7974",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2383 22.5133V19.8633",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7578 22.5133V19.8633",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2647 30.7949H22.5117V28.5354C22.5114 28.2383 22.5697 27.944 22.6833 27.6695C22.7969 27.3949 22.9636 27.1455 23.1737 26.9354C23.3838 26.7253 23.6332 26.5587 23.9078 26.4451C24.1823 26.3315 24.4766 26.2731 24.7737 26.2734C25.373 26.2734 25.9477 26.5115 26.3714 26.9352C26.7952 27.359 27.0332 27.9337 27.0332 28.5329V30.7924H26.2802",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7695 25.5266V23.1836",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2247 27.7852C13.8254 27.7854 13.4425 27.9442 13.1601 28.2265C12.8778 28.5089 12.719 28.8918 12.7188 29.2912C12.7189 29.6906 12.8776 30.0736 13.16 30.3561C13.4423 30.6386 13.8253 30.7974 14.2247 30.7977C14.6242 30.7974 15.0071 30.6386 15.2895 30.3561C15.5719 30.0736 15.7306 29.6906 15.7307 29.2912C15.7305 28.8918 15.5717 28.5089 15.2894 28.2265C15.007 27.9442 14.6241 27.7854 14.2247 27.7852Z",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2266 27.7846V23.1846",
    stroke: "#005596",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountManagement);
export default __webpack_public_path__ + "static/media/account-management.707ed7e27bffea57f8dc7fc3477bac2e.svg";
export { ForwardRef as ReactComponent };